<template>
  <v-container class="darkgray fluid toolbar py-0">
    <v-layout wrap>
      <v-flex md8>
        <a class="py-2 logo-mobile" href="http://www.entertainmentcalendar.com/">
          <img src="./../assets/ec-logo-white-mobile.svg" />
        </a>
        <a class="py-2 logo" href="http://www.entertainmentcalendar.com/">
          <img src="./../assets/ec-logo-white.svg" />
        </a>
      </v-flex>
      <v-flex md4 class="linkss">
        <a href="https://www.kidsoutandabout.com/content/master-guide-covid-19-online-activities-kids-teens-families-and-adults"> Click here for online activities, live events, and classes for kids & families during COVID-19</a>
        <!-- <div>
        <a class="mint" href="#">
          <img src="./../assets/icon-map.svg" />
        </a>
        </div>
        <div>
        <a class="grape" href="#">
          <img src="./../assets/icon-ad.svg" />
        </a>
        </div>
        <div>
        <a class="midnight" href="#">
          <img src="./../assets/icon-mail.svg" />
        </a>
        </div> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "EtHeader"
};
</script>

<style>

.toolbar .layout {
  max-width: 1185px;
  margin: 0 auto;
  min-height: 50px;
}

.toolbar .logo,
.toolbar .logo-mobile {
  padding-right: 10px;
}

.toolbar .logo {
  display: none;
}

.toolbar .logo-mobile {
  display: flex;
  align-items: center;
  min-height: 100%;
}

.toolbar .logo img {
  width: 500px;
  max-width: 100%;
}

.toolbar .links img {
  width: 40px;
  display: block !important;
}

.toolbar .links div {
  align-items: stretch;
  display: flex;
}

.toolbar .links {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
}

.toolbar .links a {
  align-items: center;
  justify-content: center;
  align-content: center;
  padding: 3px;
  display: flex;
  transition: all .2s ease;
}
.toolbar .linkss {
  background: red;
  color: #ffffff;
  padding: 20px;
  font-size: 16px;
    text-align: center;
}
.toolbar .linkss a{
  color: #ffffff;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
    text-align: center;
}
.toolbar .links a.mint:hover {
  background: #0ca29f !important;
}

.toolbar .links a.grape:hover {
  background: #82267d !important;
}

.toolbar .links a.midnight:hover {
  background: #005b8e !important;
}

@media screen and (min-width:600px) {
  .toolbar .logo-mobile {
    display: none;
  }

  .toolbar .logo {
    display: block;
  }

  .toolbar .links a {
    width: 60px;
  }
}

@media screen and (max-width:600px) {
  .toolbar.container {
    padding-right: 0;
     padding-left: 0;
  }
}

@media screen and (min-width:960px) {
  .toolbar .links a {
    width: 80px;
  }

  .toolbar .links a img {
    width: 55px;
  }

  .toolbar.container .layout {
    padding: 0 15px;
  }
}

</style>
